import { render } from "./BadgeList.vue?vue&type=template&id=2856c253"
import script from "./BadgeList.vue?vue&type=script&lang=ts"
export * from "./BadgeList.vue?vue&type=script&lang=ts"
script.render = render

export default script